import { Link } from "react-router-dom";

/**
 * Small shared layout for the Fortiqa marketing/info pages. Keeps every
 * footer destination visually consistent — back link, eyebrow, h1,
 * intro, then the page-specific children.
 */
export default function MarketingPageShell({
  eyebrow,
  title,
  intro,
  testid,
  children,
}) {
  return (
    <>
      <header className="px-6 lg:px-10 max-w-7xl mx-auto pt-16 sm:pt-20 pb-10 sm:pb-14">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#5c6360] hover:text-[#114232] mb-8 sm:mb-10"
          data-testid={`${testid}-back`}
        >
          ← Back
        </Link>
        <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#c15337] mb-3">
          {eyebrow}
        </div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[0.95] text-[#114232] max-w-3xl">
          {title}
        </h1>
        {intro && (
          <p className="text-base sm:text-lg text-[#5c6360] max-w-2xl mt-5 sm:mt-6 leading-relaxed">
            {intro}
          </p>
        )}
      </header>
      {children}
    </>
  );
}
